import * as theme from "../../theme";
import Button from "react-bootstrap/Button";
import { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import _ from "lodash";
import { BMS_ARRAY } from "../../helper/constants";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  getUserInformation,
  getUserDetails,
  getUpdateButtonStatus,
  toggleUpdateButton,
  geNewUserModelStatus,
  toggleNewUserModel,
  getUpdateUserModelStatus,
  toggleUpdateUserModel,
  selectUpdateUser,
  getUpdateUserSelected,
  updateDetails,
  addNewUser,
  getAllUsers,
  getAllUsersList,
  getUpdateErrors,
} from "../../store/userManagement";
import {
  getIsBpSuccess,
  updateBmsInfo,
  getIsProspectUpdating,
} from "../../store/qf";
import { toast } from "react-toastify";
import ReactSelect from "react-select";
import {
  getBrokeragesList,
  loadBrokerages,
  brokerageSelected,
} from "../../store/brokerages";
import EpicWorkflow from "./EpicWorkflow";
import Select from "react-dropdown-select";
import { SdCardSharp } from "@material-ui/icons";
import {
  getBrokerageInformation,
  getDetailsAdmin,
  updateBMS,
  getIsUpdating,
} from "../../store/brokerage";
import { useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { getBrokerInformation, verifyToken } from "../../store/broker";
import translations from "../../utils/translations";

const BmsView = (props) => {
  const isUpdateEnabled = useSelector(getUpdateButtonStatus);
  const dispatch = useDispatch();
  let data = { brokerage_code: props.brokerageCode };
  let qAdminText = props.isQadmin ? `for ${props.brokerageCode}` : "";
  useEffect(() => {
    dispatch(getUserDetails(data));
  }, []);
  const isUpdating = useSelector(getIsUpdating);
  const information = useSelector(getBrokerageInformation);
  const isBMSUpdating = useSelector(getIsProspectUpdating);
  let userList = useSelector(getUserInformation);
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;

  const onUpdateChangeHandle = (value) => {
    dispatch(toggleUpdateButton(value));
  };

  const onNewUserModelChangeHandle = (value) => {
    dispatch(getAllUsers());
    dispatch(toggleNewUserModel(value));
  };

  const onUpdateUserModelChangeHandle = (value, user) => {
    dispatch(selectUpdateUser(user));
    dispatch(toggleUpdateUserModel(value));
  };
  const allFalseDefault = [false, false, false];
  const [bmsState, updateBMSstate] = useState(allFalseDefault);
  const [bmsVendor, updateBMSvendor] = useState({});
  const [bmsWorkflowdetails, setBMSworkflowdetails] = useState({});
  const [isLoading, setisLoading] = useState(true);
  const handleChange = (indx) => (event) => {
    updateBMSstate((prevState) => {
      const tmpPrevState = [...prevState];
      tmpPrevState[indx] = event.target.checked;
      return tmpPrevState;
    });
    // console.log(indx)
    // console.log(event.target.checked)
  };
  const handleVendorChange = (event) => {
    updateBMSvendor(event);
  };
  const save = () => {
    let payload = {
      branchKeys,
      vendor: bmsVendor?.value,
      workflow: bmsState,
      brokerage_code: props.brokerageCode,
      workflow_details: bmsWorkflowdetails,
    };
    console.log(payload);
    dispatch(updateBMS(payload));
  };

  let branch_keys = information.address?.map(
    (x) => x.addr_line1 + " " + x.city + " " + x.postal_code
  );
  let initalBranchObj = [];

  if (branch_keys) {
    initalBranchObj = branch_keys?.map((x) => ({ branch: x, code: null }));
  }
  const [branchKeys, setbranchKeys] = useState(initalBranchObj);
  let [bmsButtonClicked, setbmsButtonClicked] = useState(false);
  useEffect(() => {
    setisLoading(true);
    if (!information.otherinfo || !information.otherinfo.bms) {
      updateBMSstate(allFalseDefault);
      updateBMSvendor({});
      setBMSworkflowdetails({});
    } else if (information.otherinfo.bms) {
      let vendor = information.otherinfo.bms.vendor;
      updateBMSstate(information.otherinfo.bms.workflow);
      updateBMSvendor({ value: vendor, label: vendor });
      setBMSworkflowdetails(
        structuredClone(information.otherinfo.bms.workflow_details || {})
      );
    }
    if (information.otherinfo?.bms?.branchkeys) {
      for (let val of information.otherinfo.bms.branchkeys) {
        if (Object.keys(initalBranchObj).includes(val)) {
          // setbranchKeys( prevState => ({
          //   ...prevState,
          //   {}
          //   [val]: information.otherinfo.bms.branchkeys[val]
          // }));
          setbranchKeys((prevState) =>
            prevState.map((item) =>
              item.branch == val.branch ? { ...val } : item
            )
          );
          //initalBranchObj[val] = information.otherinfo.bms.branchkeys[val]
        }
      }
    }
    setTimeout(() => {
      setisLoading(false);
    }, 500);
  }, [information]);

  useEffect(() => {
    if (bmsButtonClicked && !isBMSUpdating) {
      setbmsButtonClicked(false);
      dispatch(getUserDetails({ brokerage_code: props.brokerageCode }));
      dispatch(getDetailsAdmin(props.brokerageCode));
    }
  }, [isBMSUpdating]);

  return (
    <div className="m-4">
      <div className="d-flex">
        <div
          className="m-4"
          style={{
            width: "100%",
          }}
        >
          <div
            className="d-flex"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "1.2vw",
            }}
          >
            {translations[languagepreference].brokerageAdmin.bmsHeader}
            {qAdminText}
          </div>

          <div
            className=""
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              paddingTop: "25px",
              fontSize: "1vw",
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <label style={{ marginRight: "10px", fontSize: "1.9vmin" }}>
                {translations[languagepreference].brokerageAdmin.bmsSelectText}
              </label>
              <div className="">
                <ReactSelect
                  className="form-select"
                  placeholder="Select BMS Vendor"
                  onChange={handleVendorChange}
                  // defaultValue={()=>{}}
                  value={bmsVendor}
                  options={BMS_ARRAY.map((x) => {
                    return { label: x, value: x };
                  })}
                  styles={{
                    width: "100%",
                    control: (provided) => ({
                      ...provided,
                      width: "100%",
                      minWidth: "250px",
                      fontSize: "1.9vmin",
                      border: "4px solid light",
                      borderRadius: 15,
                      fontFamily: "GibsonRegular",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      minWidth: "250px",
                    }),
                  }}
                />
              </div>
            </div>
            <br />
            <div>
              <br />

              <p>
                {" "}
                {
                  translations[languagepreference].brokerageAdmin
                    .bmsSelectWorkflow
                }
              </p>
              <CommonInputCheckBoxField
                name={"newProspect"}
                label={
                  translations[languagepreference].brokerageAdmin
                    .bmsCreateProspect
                }
                checked={bmsState[0]}
                onChange={handleChange(0)}
              ></CommonInputCheckBoxField>
              <CommonInputCheckBoxField
                name={"updateProspect"}
                label={
                  translations[languagepreference].brokerageAdmin
                    .bmsUpdateProspect
                }
                checked={bmsState[1]}
                onChange={handleChange(1)}
              ></CommonInputCheckBoxField>
              <CommonInputCheckBoxField
                name={"updateOnBind"}
                label={
                  translations[languagepreference].brokerageAdmin.bmsUpdateBind
                }
                checked={bmsState[2]}
                onChange={handleChange(2)}
              ></CommonInputCheckBoxField>
            </div>
            <div>
              <Button
                onClick={(event) => {
                  console.log("Clicked");
                  setbmsButtonClicked(true);
                  dispatch(
                    updateBmsInfo({
                      action: "brokerage_config",
                      postdata: { brokerage_code: props.brokerageCode },
                    })
                  );
                }}
              >
                Fetch BMS Broker Configuration
                <Spinner
                  style={{
                    display: isBMSUpdating ? "inline-flex" : "none",
                    marginLeft: "1vw",
                  }}
                  animation="border"
                  size="sm"
                  variant="light"
                />
              </Button>
            </div>
            <br />
            Branch Codes
            <br />
            {branchKeys?.map((item, index) => {
              return (
                <Fragment key={index}>
                  <div
                    className=""
                    style={{
                      display: "inline-flex",
                      width: "100%",
                      maxWidth: "100%",
                    }}
                  >
                    <label for={item} className="col-form-label col-sm-6">
                      {item.branch}
                    </label>
                    <input
                      className="form-control"
                      id={item}
                      placeholder={`Enter Broker Code for Branch ${index + 1}`}
                      onBlur={(event) => {
                        setbranchKeys((prevState) =>
                          prevState.map((itemx) =>
                            itemx.branch == item.branch
                              ? { ...itemx, code: event.target.value }
                              : itemx
                          )
                        );
                        //initalBranchObj[item] = event.target.value;
                      }}
                      defaultValue={item.code}
                    />
                  </div>
                </Fragment>
              );
            })}
            <br />
            <br />
            <br />
            <EpicWorkflow
              bmsWorkflowdetails={bmsWorkflowdetails}
              setBMSworkflowdetails={setBMSworkflowdetails}
              isLoading={isLoading}
              bmsVendor={bmsVendor?.value}
            ></EpicWorkflow>
            <div className="form-group row justify-content-center">
              <div className="col-6">
                <button
                  type="button"
                  style={{
                    backgroundColor: "#4cabd4",
                    borderRadius: "20px",
                  }}
                  className="btn btn-primary btn-block"
                  onClick={() => {
                    save();
                  }}
                >
                  {isUpdating ? (
                    <Spinner animation="border" size="sm" variant="light" />
                  ) : (
                    translations[languagepreference].save
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const CommonInputCheckBoxField = ({
  label = "Sample common label",
  onChange,
  value,
  name,
  checked,
  defaultChecked,
  disabled,
  data,
  labelDisplay,
}) => {
  return (
    <div className="form-group row">
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          style={{
            transform: "scale(2)",
            marginLeft: "0.3px",
          }}
          id={name}
          value={value}
          onChange={onChange}
          checked={checked}
          defaultChecked={defaultChecked}
        />
      </div>
      <label
        className="ml-5 col-form-label"
        for={name}
        style={{
          fontWeight: "bold",
          marginTop: "-6px",
          fontSize: "16px",
          color: theme.COLORS.grey_font_header,
        }}
      >
        {label}&nbsp;&nbsp; &nbsp;
        <span
          id={data}
          style={{
            color: "grey",
          }}
        >
          {labelDisplay}
        </span>
      </label>
    </div>
  );
};

export default BmsView;
